'use strict';
/**
 * textSplit
 */
export const textSplit = (() => {
    const $textSplit = $('.js-textsplit');
    let delay = 0;
    let prev = 0;

    const splitSet = () => {
        $textSplit
            .children()
            .addBack()
            .contents()
            .each(function () {
                if (this.nodeType == 3) {
                    const $this = $(this);

                    setTimeout(() => {
                        $this.replaceWith($this.text().replace(/(\S)/g, '<span>$&</span>'));
                    }, 100);
                }
            });
    };

    const init = () => {
        splitSet();
    };

    // public
    return {
        init: init
    };
})();
